export const myStatus: CMx.MyStatusState = {
  myStatusIsOpen: false,
  activeStatus: '',
  statusList: { columnNames: [], numRows: 0, rowValues: [] }
};
